import { Cliente } from '@/types/cliente'
import { Oportunidade } from '@/types/oportunidade'

export const mockClientes: Cliente[] = [
  {
    id: '1',
    razaoSocial: 'Tech Solutions Ltda',
    cnpj: '12345678000190',
    tipo: 'PJ',
    status: 'ATIVO',
    setorIndustria: 'Tecnologia',
    faturamentoAnual: 5000000,
    createdAt: '2024-01-15T10:30:00Z',
    updatedAt: '2024-03-10T14:20:00Z',
    contatos: [
      {
        id: 'c1',
        nome: 'João Silva',
        email: 'joao@techsolutions.com',
        telefone: '11987654321',
        cargo: 'Diretor Financeiro',
        principal: true,
      },
      {
        id: 'c2',
        nome: 'Maria Santos',
        email: 'maria@techsolutions.com',
        telefone: '11987654322',
        cargo: 'Gerente de Projetos',
        principal: false,
      },
    ],
  },
  {
    id: '2',
    razaoSocial: 'Comércio & Logística Express',
    cnpj: '98765432000180',
    tipo: 'PJ',
    status: 'ATIVO',
    setorIndustria: 'Logística',
    faturamentoAnual: 8500000,
    createdAt: '2023-11-20T09:15:00Z',
    updatedAt: '2024-03-08T11:45:00Z',
    contatos: [
      {
        id: 'c3',
        nome: 'Carlos Oliveira',
        email: 'carlos@comercioexpress.com',
        telefone: '21987654321',
        cargo: 'Presidente',
        principal: true,
      },
    ],
  },
  {
    id: '3',
    razaoSocial: 'Consultoria Premium Brasil',
    cnpj: '11223344000155',
    tipo: 'PJ',
    status: 'PROSPECT',
    setorIndustria: 'Consultoria',
    faturamentoAnual: 3200000,
    createdAt: '2024-02-28T16:00:00Z',
    updatedAt: '2024-03-10T13:30:00Z',
    contatos: [],
  },
  {
    id: '4',
    razaoSocial: 'Manufatura 360 Indústrias',
    cnpj: '55667788000122',
    tipo: 'PJ',
    status: 'INATIVO',
    setorIndustria: 'Manufatura',
    faturamentoAnual: 12000000,
    createdAt: '2023-08-10T14:20:00Z',
    updatedAt: '2024-02-15T10:10:00Z',
    contatos: [
      {
        id: 'c4',
        nome: 'Roberto Gomes',
        email: 'roberto@manufatura360.com',
        telefone: '31987654321',
        cargo: 'CFO',
        principal: true,
      },
    ],
  },
]

export const mockOportunidades: Oportunidade[] = [
  {
    id: '1',
    clienteId: '1',
    nomeCliente: 'Tech Solutions Ltda',
    tipoNecessidade: 'Capital de Giro',
    produtoId: null,
    valorEstimado: 500000,
    descricao: 'Necessidade de capital para expansão de operações',
    estagio: 'DIAGNOSTICO',
    createdAt: '2024-03-01T10:00:00Z',
    updatedAt: '2024-03-10T15:30:00Z',
  },
  {
    id: '2',
    clienteId: '1',
    nomeCliente: 'Tech Solutions Ltda',
    tipoNecessidade: 'Vendor Finance',
    produtoId: null,
    valorEstimado: 800000,
    descricao: 'Financiamento para compra de equipamentos',
    estagio: 'ESTRUTURACAO',
    createdAt: '2024-02-15T09:30:00Z',
    updatedAt: '2024-03-09T14:15:00Z',
  },
  {
    id: '3',
    clienteId: '2',
    nomeCliente: 'Comércio & Logística Express',
    tipoNecessidade: 'Antecipação de Recebíveis',
    produtoId: null,
    valorEstimado: 1200000,
    descricao: 'Antecipação de recebíveis para fluxo de caixa',
    estagio: 'NEGOCIACAO',
    createdAt: '2024-01-20T11:00:00Z',
    updatedAt: '2024-03-10T16:45:00Z',
  },
  {
    id: '4',
    clienteId: '3',
    nomeCliente: 'Consultoria Premium Brasil',
    tipoNecessidade: 'Capital de Giro',
    produtoId: null,
    valorEstimado: 350000,
    descricao: 'Reforço de caixa para novo contrato',
    estagio: 'DIAGNOSTICO',
    createdAt: '2024-03-05T13:20:00Z',
    updatedAt: '2024-03-10T12:00:00Z',
  },
]

// mockDocumentos foi removido: nao tinha consumidor e ainda declarava campos que a
// API nunca enviou (uploadPor, tipo EXTRATO). Mock desatualizado e nao exercitado
// vira documentacao falsa do contrato — foi o que segurou a ficcao em types/documento.ts.
